module.exports = __webpack_public_path__ + "static/media/feishu_OKR.85dbcbb1.png";